module.exports = __webpack_public_path__ + "img/Componente 32 – 1.0ed44b48.svg";